import DataVCapsuleChart from './capsule-chart';
export default DataVCapsuleChart;
